import { createStyles, makeStyles } from '@material-ui/core';
import type { Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) => {
    return createStyles({
        root: {
            '& .ql-toolbar.ql-snow': {
                borderBottom: `1px solid ${theme.palette.divider}`,
                borderLeft: 'none',
                borderRight: 'none',
                borderTop: 'none',
                padding: theme.spacing(1, 0),
                '& .ql-picker-label:hover': {
                    color: theme.palette.primary.main,
                },
                '& .ql-picker-label.ql-active': {
                    color: theme.palette.primary.main,
                },
                '& .ql-picker-item:hover': {
                    color: theme.palette.primary.main,
                },
                '& .ql-picker-item.ql-selected': {
                    color: theme.palette.primary.main,
                },
                '& .ql-picker-item:focus': {
                    outlineWidth: 0,
                },
                '& .ql-formats': {
                    marginRight: 0,
                },
                '& button': {
                    backgroundColor: theme.palette.grey[200],
                    borderRadius: theme.shape.borderRadius / 2,
                    marginLeft: 0,
                    marginRight: theme.spacing(1),
                    '& .ql-stroke': {
                        stroke: theme.palette.grey[700],
                    },
                },
                '& button:hover': {
                    backgroundColor: theme.palette.grey[300],
                    '& .ql-stroke': {
                        stroke: theme.palette.primary.main,
                    },
                    '& .ql-fill': {
                        fill: theme.palette.primary.main,
                    },
                },
                '& button:focus': {
                    backgroundColor: theme.palette.grey[300],
                    '& .ql-stroke': {
                        stroke: theme.palette.primary.main,
                    },
                    '& .ql-fill': {
                        fill: theme.palette.primary.main,
                    },
                },
                '& button.ql-active': {
                    backgroundColor: theme.palette.primary.main,
                    '& .ql-stroke': {
                        stroke: theme.palette.primary.contrastText,
                    },
                    '& .ql-fill': {
                        fill: theme.palette.primary.contrastText,
                    },
                },
                '& button.ql-active:hover': {
                    backgroundColor: theme.palette.primary.dark,
                    '& .ql-stroke': {
                        stroke: theme.palette.primary.contrastText,
                    },
                    '& .ql-fill': {
                        fill: theme.palette.primary.contrastText,
                    },
                },
                '& .ql-stroke': {
                    stroke: theme.palette.text.primary,
                },
                '& .ql-picker': {
                    color: theme.palette.text.primary,
                    marginLeft: 0,
                    marginRight: theme.spacing(1),
                },
                '& .ql-picker-label': {
                    alignItems: 'center',
                    backgroundColor: theme.palette.grey[200],
                    border: 'none',
                    borderRadius: theme.shape.borderRadius / 2,
                    color: theme.palette.text.primary,
                    outline: 'none',
                },
                '& .ql-picker-options': {
                    backgroundColor: theme.palette.background.paper,
                    border: 'none',
                    borderRadius: theme.shape.borderRadius / 2,
                    boxShadow: theme.shadows[1],
                    outline: 'none',
                    padding: 5,
                    paddingLeft: 6,
                },
            },
            '& .ql-container.ql-snow': {
                border: 'none',
                '& .ql-editor': {
                    color: theme.palette.text.primary,
                    fontFamily: theme.typography.fontFamily,
                    fontSize: 16,
                    padding: theme.spacing(1, 0),
                    minHeight: 96,
                    '&.ql-blank::before': {
                        color: theme.palette.grey[500],
                        fontStyle: 'normal',
                        left: theme.spacing(1),
                        right: theme.spacing(1),
                    },
                },
            },
        },
    });
};

export default makeStyles(styles, { name: 'MuiQuillEditor' });
